import { requestApi } from './Api';

export const getBalance = (navigate, params, opts = {}) =>
  requestApi({
    navigate,
    url: '/api/patient/transaction/balance',
    params,
    ...opts
  });

export const readBalance = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/patient/balance/read',
    params
  });

export const unAllocateBalance = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/patient/balance/unallocate',
    params
  });

export const deleteWriteOff = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/writeoff/remove',
    params
  });

export const getInvoices = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/appointment/invoices/get',
    params
  });

export const getInvoicesCSV = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/appointment/invoices/get_csv',
    params
  });

export const getTransactions = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/list',
    params
  });

export const getAllTransactions = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/list_all',
    params
  });

export const lookupLiveTransaction = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/transaction_lookup',
    params
  });

export const recheckTransaction = (navigate, params) =>
  requestApi({ navigate, url: 'api/transactions/recheck', params });

export const getTransactionsCSV = (navigate, params) =>
  requestApi({ navigate, url: '/api/transactions/get_csv', params });

export const calculateBalance = (navigate, params) =>
  requestApi({
    params,
    navigate,
    url: '/api/patient/transaction/calculate_balance'
  });

export const getTransactionActivities = (navigate, params) =>
  requestApi({
    url: '/api/transactions/activity/get',
    params,
    navigate
  });

export const terminalTransactionInitiate = (navigate, params) =>
  requestApi({
    url: '/api/transactions/terminal/transaction/initiate',
    params,
    navigate
  });

export const processPayrocPayment = (navigate, params) =>
  requestApi({
    url: '/api/transactions/payroc/process_payment',
    params,
    navigate
  });

export const savePayrocCard = (navigate, params) =>
  requestApi({
    url: '/api/transactions/payroc/save_card',
    params,
    navigate
  });

export const getPayrocSessionToken = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/payroc/get_session_token',
    params
  });

export const chargeSavedCard = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/token/sale',
    params
  });

export const chargeCash = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/cash/add',
    params
  });

export const chargeElavonCard = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/token/add',
    params
  });

export const chargeElavonOnline = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/online/sale',
    params
  });

export const getElavonOnlineCredentials = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/online/getCredentials',
    params
  });

export const noPaymentSelected = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/appointment/no_payment_selected',
    params
  });

export const chargeAppliedBalance = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/credit/allocate',
    params
  });

export const getUnallocatedBalance = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/patient/balance/unallocated_balance',
    params
  });

export const getReceipt = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/receipt/get',
    params
  });

export const sendReceiptByEmail = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/receipt/email',
    params
  });

export const refundTransaction = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/online/refund',
    params
  });

export const fixInvoicesAndBalance = (navigate, params) =>
  requestApi({
    params,
    navigate,
    url: '/api/patient/transaction/fix_invoices_and_balance'
  });
